import ErrorPage from './error/ErrorPage';
import Home from './home/Home';
import Time from './time';
import License from './license';

const routes = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/time',
    component: Time,
    exact: true,
  },
  {
    path: '/license',
    component: License,
    exact: true,
  },
  {
    path: '/error',
    component: ErrorPage,
    exact: true,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js